/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { Container, Spinner, Tab, Tabs, Modal } from "react-bootstrap";
import {
  faCircleInfo,
  faShareNodes,
  faSignal,
  faPencilAlt,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./HiringManagerKanboard.scss";
import useHiringManagerKanboard from "./useHiringManagerKanboard";
import { dateFormatter } from "../../../_helpers/dateFormatter";
import CandidateKanbanSearch from "./CandidateKanbanSearch";
import MainLayout from "../../Common/MainLayout";
import {
  kanbanAssessmentFilter,
  kanbanInterviewFilter,
  kanbanOfferFilter,
} from "./consts";
import KanbanJobCard from "../../../_uiComponents/KanbanJobCard";
import KanbanCandidatesTable from "../../../_uiComponents/KanbanCandidatesTable";

export default (props) => {
  const {
    columns,
    jobDetails,
    jobDetailsData,
    loading,
    suggestedMentors,
    appliedMentors,
    appliedMentorsLoading,
    showSearch,
    searchInputRef,
    candidateKanbanSearchList,
    candidateKanbanSearchLoading,
    showInviteModal,
    scheduleInterviewModal,
    calendarEventLists,
    toggleView,
    candidatesList,
    currentTab,
    stageLoading,
    listView,
    onDragEnd,
    onNavigationClick,
    onViewMentorDetails,
    onViewMentorsApplied,
    onJobShareClick,
    onViewMentorProfileClick,
    onSearch,
    onSearchInputChange,
    onEditJob,
    onScheduleInterviewClick,
    setLastElement,
    onEventEditClick,
    onAssignInterviewEventClick,
    onCreateEventClick,
    showInviteModalHandler,
    onInviteClick,
    onAssessmentFilterChange,
    onInterviewFilterChange,
    onOfferFilterChange,
    onToggleViewClick,
    currentTabHandler,
    changeStageHandler
  } = useHiringManagerKanboard(props);

  const checkTags = (column, cardData) => {
    let tag = null;

    if (column.name === "ASSESSMENT") {
      if (
        Array.isArray(cardData?.assessment_kit_submitted_details) &&
        Array.isArray(cardData?.assessment_kit_details)
      ) {
        tag =
          cardData?.assessment_kit_submitted_details[0]?.interview_submitted ===
            true ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Submitted
            </span>
          ) : cardData?.assessment_kit_details[0]?.kit_accepted ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Accepted
            </span>
          ) : cardData?.assessment_kit_details[0]?.kit_declined ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Declined
            </span>
          ) : (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Pending
            </span>
          );
      }
    }

    if (column.name === "INTERVIEW") {
      if (Array.isArray(cardData?.interview_details)) {
        let interviewLength = cardData.interview_details.length;
        tag =
          interviewLength &&
            cardData.interview_details[0]?.room_videos.length === true ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Completed
            </span>
          ) : interviewLength ? (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Scheduled
            </span>
          ) : (
            <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
              Pending
            </span>
          );
      }
    }

    if (column.name === "OFFER") {
      tag =
        cardData?.job_offer_details?.offer_accepted === true ? (
          <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
            Accepted
          </span>
        ) : cardData?.job_offer_details?.offer_rejected === true ? (
          <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
            Rejected
          </span>
        ) : (
          <span className="label-light-green d-inline-block border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2">
            Pending
          </span>
        );
    }
    return tag;
  };

  return (
    <MainLayout activeMenuItem="kanban" pageName="Kanban Board">
      <div className="kanban-board-main">
        <KanbanJobCard
          jobDetails={jobDetails}
          onJobShareClick={onJobShareClick}
          showSearch={showSearch}
          onSearchInputChange={onSearchInputChange}
          searchInputRef={searchInputRef}
          onSearch={onSearch}
          onToggleViewClick={onToggleViewClick}
          listView={listView}
        />
        {toggleView ?
          <Container>
            {showSearch ? (
              <CandidateKanbanSearch
                candidateKanbanSearchList={candidateKanbanSearchList}
                onNavigationClick={onNavigationClick}
                candidateKanbanSearchLoading={
                  candidateKanbanSearchLoading
                }
              />
            ) : (
                <KanbanCandidatesTable
                  checkTags={checkTags}
                  stageLoading={stageLoading}
                  candidateKanbanSearchLoading={candidateKanbanSearchLoading}
                  onNavigationClick={
                    onNavigationClick
                  }
                  candidatesList={candidatesList}
                  currentTabHandler={currentTabHandler}
                  currentTab={currentTab}
                  changeStageHandler={changeStageHandler}

                />
            )
            }
          </Container>
          :
          <div className="kanban-board-wrapper">
            {loading ? (
              <div className="p-5 text-center">
                <Spinner
                  animation="border"
                  variant="primary"
                  className="text-center"
                />
              </div>
            ) : (
              <div className="container ">
                <div className="wrapper-right ">
                  {showSearch ? (
                    <>
                      <CandidateKanbanSearch
                        candidateKanbanSearchList={candidateKanbanSearchList}
                        onNavigationClick={onNavigationClick}
                        candidateKanbanSearchLoading={
                          candidateKanbanSearchLoading
                        }
                      />
                    </>
                  ) : (
                    <>
                      {/* kanban board search  */}
                      <Tabs defaultActiveKey="Kanboard" className="mt-3">
                        <Tab eventKey="Kanboard" title="Kanban Board">
                          <div className="d-flex kanboard-row">
                            {columns && (
                              <DragDropContext onDragEnd={onDragEnd}>
                                {Object.entries(columns).map(
                                  ([columnId, column], index) => (
                                    <div
                                      className="kanboard-column"
                                      key={columnId}
                                    >
                                      <h3
                                        className={`title w-100  p-3 justify-content-between ${column.label}
                            `}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span className="mr-2">
                                            {column.name}
                                          </span>
                                          <span>
                                            (
                                            {column?.items && column.items.length}
                                            )
                                          </span>
                                        </div>
                                        {column.name === "ASSESSMENT" && (
                                          <div className="select">
                                            <select
                                              className="border mt-1 px-2 py-1 fs-smallest rounded  text-dark"
                                              onChange={onAssessmentFilterChange}
                                            >
                                              {kanbanAssessmentFilter.map(
                                                (item) => (
                                                  <option value={item}>
                                                    {item}{" "}
                                                  </option>
                                                )
                                              )}
                                            </select>
                                          </div>
                                        )}
                                        {column.name === "INTERVIEW" && (
                                          <div className="select">
                                            <select
                                              className="border mt-1 px-2 py-1 fs-smallest rounded  text-dark"
                                              onChange={onInterviewFilterChange}
                                            >
                                              {kanbanInterviewFilter.map(
                                                (item) => (
                                                  <option value={item}>
                                                    {item}{" "}
                                                  </option>
                                                )
                                              )}
                                            </select>
                                          </div>
                                        )}
                                        {column.name === "OFFER" && (
                                          <div className="select">
                                            <select
                                              className="border mt-1 px-2 py-1 fs-smallest rounded  text-dark"
                                              onChange={onOfferFilterChange}
                                            >
                                              {kanbanOfferFilter.map((item) => (
                                                <option value={item}>
                                                  {item}{" "}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        )}
                                      </h3>

                                      <Droppable
                                        droppableId={columnId}
                                        key={columnId}
                                        index={index}
                                        className="bg-grey-3 px-2 py-3"
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            style={{
                                              background: snapshot.isDraggingOver
                                                ? "#F4F5F7"
                                                : "#f4f5f7",
                                              minHeight: 300,
                                            }}
                                            className="task-card-list"
                                          >
                                            {
                                              <>
                                                {column.loading ? (
                                                  <div className="d-flex align-items-center justify-content-center mt-3">
                                                    <Spinner
                                                      animation="border"
                                                      variant="primary"
                                                    />
                                                  </div>
                                                ) : (
                                                  <>
                                                    {Array.isArray(
                                                      column.items
                                                    ) && column.items.length ? (
                                                      <>
                                                        {column.items &&
                                                          Array.isArray(
                                                            column.items
                                                          ) &&
                                                          column.items.map(
                                                            (item, index) => (
                                                              <Draggable
                                                                draggableId={item.id.toString()}
                                                                index={index}
                                                                key={item.id.toString()}
                                                              >
                                                                {(
                                                                  provided,
                                                                  snapshot
                                                                ) => (
                                                                  <div
                                                                    ref={
                                                                      provided.innerRef
                                                                    }
                                                                    snapshot={
                                                                      snapshot
                                                                    }
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className="rounded-lg shadow task-card mb-2 p-3 mx-2"
                                                                    style={{
                                                                      userSelect:
                                                                        "none",
                                                                      backgroundColor:
                                                                        snapshot.isDragging
                                                                          ? "#e8e9eb"
                                                                          : "#ffffff",
                                                                      ...provided
                                                                        .draggableProps
                                                                        .style,
                                                                    }}
                                                                  >
                                                                    {checkTags(
                                                                      column,
                                                                      item
                                                                    )}
                                                                    {
                                                                      provided.placeholder
                                                                    }

                                                                    {item
                                                                      ?.invite_details
                                                                      ?._id && (
                                                                        <p className="h6 text-grey-4 font-weight-normal">
                                                                          <span className="bg-grey-2 text-dark border-0 rounded-sm p-1 mt-1 fs-smallest line-height-14 mb-2 text-nowrap">
                                                                            Candidate
                                                                            invited
                                                                            by{" "}
                                                                            {
                                                                              item
                                                                                ?.invite_details
                                                                                ?.name
                                                                            }
                                                                          </span>
                                                                        </p>
                                                                      )}

                                                                    <div className="d-flex justify-content-between align-items-start">
                                                                      <div>
                                                                        <button
                                                                          onClick={() =>
                                                                            onNavigationClick(
                                                                              item?.id
                                                                            )
                                                                          }
                                                                          className="edit px-0 text-left font-weight-semi border-0 bg-transparent mb-2 text-capitalize text-primary"
                                                                        >
                                                                          {item?.candidate_details &&
                                                                            item
                                                                              .candidate_details
                                                                              ?.full_name}
                                                                        </button>
                                                                        <p className="h6 text-grey-4 font-weight-normal">
                                                                          {dateFormatter(
                                                                            item?.applied_date
                                                                          )}
                                                                        </p>
                                                                      </div>
                                                                    </div>
                                                                    <ul className="d-flex align-items-center flex-wrap">
                                                                      {Array.isArray(
                                                                        item
                                                                          ?.candidate_details
                                                                          ?.skills
                                                                      ) &&
                                                                        item?.candidate_details?.skills.map(
                                                                          (
                                                                            skill,
                                                                            index
                                                                          ) => (
                                                                            <li
                                                                              className="bg-white border text-capitalize text-grey-4 rounded-pill fs-smallest px-2 py-1 mr-2 my-1 rounded p-1"
                                                                              key={
                                                                                index
                                                                              }
                                                                            >
                                                                              {
                                                                                skill
                                                                              }
                                                                            </li>
                                                                          )
                                                                        )}
                                                                    </ul>
                                                                  </div>
                                                                )}
                                                              </Draggable>
                                                            )
                                                          )}
                                                      </>
                                                    ) : (
                                                      <div className="text-center rounded p-3 mx-2 mt-5">
                                                        <img
                                                          src={`/assets/images/${column.name}.svg`}
                                                          alt="no candidate"
                                                        />
                                                        <div>
                                                          {" "}
                                                          <h4 className="mb-2">
                                                            {
                                                              column.emptyState
                                                                .title
                                                            }
                                                          </h4>
                                                          <p className="fs-smallest">
                                                            {
                                                              column.emptyState
                                                                .label
                                                            }
                                                          </p>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            }{" "}
                                            {provided.placeholder}
                                          </div>
                                        )}
                                      </Droppable>
                                    </div>
                                  )
                                )}
                              </DragDropContext>
                            )}
                          </div>
                        </Tab>
                        {jobDetails?.data &&
                          jobDetails.data?.mentor_name === null && (
                            <Tab
                              eventKey="AppliedMentors"
                              title="Applied Mentors"
                            >
                              <h2 className="mb-4">
                                Showing {appliedMentors?.count} Applied Mentors
                              </h2>
                              <ul className="mentor-list row">
                                {appliedMentors?.results &&
                                  Array.isArray(appliedMentors?.results) &&
                                  appliedMentors.results.length ? (
                                  Array.isArray(appliedMentors?.results) &&
                                  appliedMentors.results.map((item) => (
                                    <li className="col-md-4" key={item?.id}>
                                      <div className="mentor-box bg-white rounded-lg border shadow-2 p-4">
                                        <div className="img-box mr-4 mb-3 d-flex">
                                          <img
                                            src={
                                              item?.mentor_details &&
                                                item.mentor_details
                                                  ?.user_meta_info &&
                                                item.mentor_details.user_meta_info
                                                  ?.profile_image == null
                                                ? "/assets/images/building-placeholder.png"
                                                : item?.mentor_details &&
                                                item.mentor_details
                                                  ?.user_meta_info &&
                                                item.mentor_details
                                                  .user_meta_info?.profile_image
                                            }
                                            alt="user img"
                                            className="user-img border-radius-10 mr-3"
                                          />
                                          <div className="info">
                                            <h3 className="mb-0 text-primary font-weight-medium">
                                              {item?.mentor_details &&
                                                item.mentor_details?.full_name}
                                            </h3>
                                            <p className="text-grey-4">
                                              {item?.mentor_profile_details &&
                                                item.mentor_profile_details
                                                  ?.headline}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="content flex-grow-1">
                                          <p className="text-grey-4">
                                            <span>
                                              <FontAwesomeIcon
                                                icon={faSignal}
                                                className="text-grey-4 mr-2"
                                              />
                                            </span>
                                            Has{" "}
                                            {item?.mentor_profile_details &&
                                              item.mentor_profile_details
                                                ?.skills &&
                                              item.mentor_profile_details.skills
                                                .length}{" "}
                                            primary skills
                                          </p>

                                          <div className="d-flex flex-wrap align-items-center mt-2">
                                            {Array.isArray(item.skills) &&
                                              item?.skills &&
                                              item.skills.map((tag) => (
                                                <>
                                                  {tag?.is_primary === true ? (
                                                    <div
                                                      className={
                                                        " bg-light-blue rounded-lg text-nowrap text-primary py-1 px-3 mr-1 text-capitalize mb-2"
                                                      }
                                                      key={tag?.id}
                                                    >
                                                      {tag?.skill_name}
                                                    </div>
                                                  ) : null}
                                                </>
                                              ))}
                                          </div>
                                          <div className="border-top pt-3 mt-3 d-flex justify-content-between align-items-center">
                                            <p className="text-grey-4">
                                              Profile matches this job
                                            </p>
                                            <button
                                              className="btn btn-primary"
                                              onClick={() =>
                                                onViewMentorProfileClick(
                                                  item?.mentor_details &&
                                                  item.mentor_details?.hash_id
                                                )
                                              }
                                            >
                                              View Details
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  ))
                                ) : (
                                  <div className="msg-bg text-white p-3 border-6 mt-5 d-flex align-items-center justify-content-center mb-2 w-50 mx-auto">
                                    <p className="mb-0">
                                      <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="text-white mr-2"
                                      />
                                      No Mentor Applied
                                    </p>
                                  </div>
                                )}
                              </ul>
                            </Tab>
                          )}
                      </Tabs>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        }

        <Modal
          show={scheduleInterviewModal}
          centered
          size="xl"
          onHide={onScheduleInterviewClick}
          className="common-modal apply-job-modal schedule-interview-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Schedule Interview</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3 bg-white">
            <div className="event-list">
              {Array.isArray(calendarEventLists) &&
                calendarEventLists.length > 0 ? (
                <>
                  {Array.isArray(calendarEventLists) &&
                    calendarEventLists.map((item) => (
                      <>
                        <div
                          className="event-box  mb-3 d-flex align-items-start justify-content-between"
                          ref={setLastElement}
                          key={item?.id}
                        >
                          <div className="content">
                            <h3 className="font-weight-semi mb-2 text-primary cursor">
                              {item?.title}
                            </h3>
                            <p className="text-grey-4">
                              Estimated time: {item?.duration} mins | One to One
                              Interview
                            </p>
                          </div>
                          <div className="action">
                            <button
                              className="btn btn-light mr-3"
                              onClick={() => onEventEditClick(item?.id)}
                            >
                              Edit
                            </button>
                            {!item?.hash_id ? (
                              <button
                                className="btn btn-primary"
                                onClick={() => onEventEditClick(item?.id)}
                              >
                                Set Availability
                              </button>
                            ) : (
                              <button
                                className={`btn btn-primary`}
                                onClick={() =>
                                  onAssignInterviewEventClick(item?.id)
                                }
                              >
                                Assign
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    ))}
                </>
              ) : (
                <div className="d-flex justify-content-between align-items-center">
                  <p>
                    No events created. Please create an event in your calendar.
                  </p>
                  <button
                    className="btn btn-primary"
                    onClick={onCreateEventClick}
                  >
                    Create Event
                  </button>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          size="sm"
          show={showInviteModal}
          onHide={() => showInviteModalHandler()}
          className="border-0 common-modal apply-job-modal"
          centered
        >
          <Modal.Header className="bg-primary text-white">
            <Modal.Title className="text-uppercase">
              <h3 className="mb-0 text-white">Invite Watcher's</h3>
            </Modal.Title>
            <FontAwesomeIcon
              icon={faXmark}
              className="fa-2x cursor-pointer"
              onClick={() => showInviteModalHandler()}
            />
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="form-group mb-0">
              <p className="font-weight-medium">
                <span className="text-danger">* </span>Enter Name
              </p>
              <div className="form-group">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Watcher's Name"
                  name="title"
                />
              </div>
            </div>
            <div className="form-group mb-0 pt-3">
              <p className="font-weight-medium">
                <span className="text-danger">* </span>Enter Email Id
              </p>
              <div className="form-group">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Watcher's Email Id"
                  name="title"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex align-items-center justify-content-end">
              <button className="btn btn-primary ml-4">Invite</button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </MainLayout>
  );
};
